export function KioskTodayHourlyChart({ hourly }) {
  if (!hourly || hourly.length === 0) {
    return <div style={{ fontSize: 12, color: '#9e9e9e' }}>No hourly data yet.</div>;
  }
  const W = 520, H = 160, PL = 28, PR = 8, PT = 10, PB = 22;
  const innerW = W - PL - PR, innerH = H - PT - PB;
  const maxVal = Math.max(1, ...hourly.flatMap(h => [Number(h.forecast) || 0, Number(h.actual) || 0]));
  const barW = innerW / hourly.length * 0.65;
  const slot = innerW / hourly.length;
  function y(v) { return PT + innerH - (v / maxVal) * innerH; }
  return (
    <svg viewBox={`0 0 ${W} ${H}`} style={{ width: '100%', height: 160, display: 'block' }}>
      {[0, 0.5, 1].map((f, i) => {
        const yy = PT + innerH * (1 - f);
        return <line key={i} x1={PL} y1={yy} x2={W - PR} y2={yy} stroke="#eee" strokeWidth="1" />;
      })}
      {hourly.map((h, i) => {
        const x = PL + slot * i + (slot - barW) / 2;
        const actual = Number(h.actual) || 0;
        const yy = y(actual);
        const isCurrent = h.isCurrent;
        return (
          <g key={i}>
            <rect x={x} y={yy} width={barW} height={Math.max(0, PT + innerH - yy)}
                   fill={isCurrent ? '#b48a47' : '#5D4037'} opacity={h.isPast ? 1 : 0.4} rx="2" />
            <text x={x + barW / 2} y={H - 6} fontSize="9" fill="#9e9e9e" textAnchor="middle">{h.label}</text>
          </g>
        );
      })}
      <polyline fill="none" stroke="#1565c0" strokeWidth="2"
        points={hourly.map((h, i) => `${PL + slot * i + slot / 2},${y(Number(h.forecast) || 0)}`).join(' ')} />
      {hourly.map((h, i) => (
        <circle key={i} cx={PL + slot * i + slot / 2} cy={y(Number(h.forecast) || 0)} r="3" fill="#1565c0" />
      ))}
    </svg>
  );
}
